import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useContext } from 'react';
import useMasterlistContext from '../context/useMasterlistContext';
import { DataGridPro } from '@mui/x-data-grid-pro';
// Heplers
import { numberFormat } from '../../../../src/helpers/helperFunctions';

export default function Table() {
  const { masterlists } = useContext(useMasterlistContext);
  const [sortModel, setSortModel] = useState([
    {
      field: 'id',
      sort: 'desc',
    },
  ]);

  const columns = [
    {
      field: 'rsm_name',
      headerName: 'Regional Manager',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'manager_name',
      headerName: 'Manager',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'rep_name',
      headerName: 'Rep Name',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'rep_designation',
      headerName: 'Rep Designation',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'md_code',
      headerName: 'MD Code',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'md_name',
      headerName: 'MD Name',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'md_group',
      headerName: 'MD Group',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'specialty',
      headerName: 'Specialty',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'frequency',
      headerName: 'Frequency',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
  ];

  return (
    <div>
      <Typography variant='h6' gutterBottom>
        No. of Doctor(s): {numberFormat(masterlists?.items?.length) ?? 0}
      </Typography>
      <Box
        className='table-container'
        sx={{
          height: `800px`,
          '& .super-app-theme--header': {
            fontWeight: 'bold',
            backgroundColor: '#6B8D3E',
            color: '#fff',
          },
        }}
      >
        <DataGridPro
          loading={masterlists?.loading}
          rows={masterlists?.items}
          columns={columns}
          sortModel={sortModel}
          initialState={{
            ...masterlists?.items?.initialState,
            pagination: {
              pageSize: 100,
            },
          }}
          rowsPerPageOptions={[25, 50, 100]}
          pagination
          onSortModelChange={(model) => setSortModel(model)}
          getRowClassName={(params) => {
            return params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row';
          }}
        />
      </Box>
    </div>
  );
}
